export const GREY = "#f0f2f5";
export const WHITE = "#FFFFFF";
export const BLUE = "#2478F6";
